import { ReactNode } from 'react';
import { IconType } from '../../Atoms/Icon';
import { CardWithTitle } from '../CardWithTitle';

export interface PageCardProps {
  title: string;
  children: ReactNode;
  headerContent?: ReactNode;
  cardActions?: ReactNode;
  titleIcon?: IconType;
  className?: string;
  childrenWrapperClass?: string;
  enableCollapse?: boolean;
  enableShadow?: boolean;
  collapsed?: boolean;
  onCollapseClick?: (collapse: boolean) => void;
  dataCy?: string;
}

export function PageCard({
  title,
  children,
  headerContent,
  cardActions,
  titleIcon,
  className,
  childrenWrapperClass,
  enableCollapse = true,
  enableShadow = false,
  collapsed = false,
  onCollapseClick,
  dataCy
}: PageCardProps) {
  return (
    <CardWithTitle
      title={title}
      enableShadow={enableShadow}
      enableCollapse={enableCollapse}
      headerContent={headerContent}
      cardActions={cardActions}
      titleIcon={titleIcon}
      className={className}
      collapsed={collapsed}
      onCollapseClick={onCollapseClick}
      dataCy={dataCy}
      childrenWrapperClass={childrenWrapperClass}>
      {children}
    </CardWithTitle>
  );
}
